import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ReservationsServices } from '../../../reservation/services';

/**
 * Generated class for the MenuTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reservation-tutorial-slide',
  templateUrl: 'reservation-tutorial-slide.html',
})
export class ReservationTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public reservationsServices: ReservationsServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_reservation = true;
    this.reservationsServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_reservation': this.globals.restaurant.tutorial_reservation,
    }).then(() => {
      this.navCtrl.pop();
    });
  }

  closeLeave(){
    this.globals.restaurant.tutorial_reservation = true;
    this.reservationsServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_reservation': this.globals.restaurant.tutorial_reservation,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/reservation-tutorial-slide/reservation-tutorial-slide.ts